import { HttpApiError } from '@backmarket/http-api'
import { putMerchantOrdersValidateOrderline } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants-orders/merchant-orders-page'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

import translations from './useConfirmOrderLines.translations'

export function useConfirmOrderLines() {
  const { openSuccessToast, openErrorToast } = useTheToast()
  const i18n = useI18n()

  async function confirmOrderLine(orderLineId: number, onSuccess: () => void) {
    try {
      await $httpFetch(putMerchantOrdersValidateOrderline, {
        pathParams: {
          orderLineId,
        },
      })
      openSuccessToast({
        content: i18n(translations.orderLineConfirmed, { orderLineId }),
      })
      onSuccess()
    } catch (error) {
      const { detail: content, title } = HttpApiError.fromAnyError(
        error as Error,
      )
      openErrorToast({ content, title })
    }
  }

  return {
    confirmOrderLine,
  }
}
